module.exports = __webpack_public_path__ + "img/2b.05c061de.jpg";